import { render, staticRenderFns } from "./DashboardTopbar.vue?vue&type=template&id=5a4c0e44"
import script from "./DashboardTopbar.vue?vue&type=script&lang=js"
export * from "./DashboardTopbar.vue?vue&type=script&lang=js"
import style0 from "./DashboardTopbar.vue?vue&type=style&index=0&id=5a4c0e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports